export default "__VITE_ASSET__875f5e6c__"